import '../../App.css';
import { childrenProps, CircledImageProps } from '../common/types';
import CircleBg from '../common/CircularBgProps';
import Image from '../common/CircularImgProps';
import React from 'react';
import BubbleHoverCircle from '../common/bubbleHover';
import globeLight from '../../assets/images/globeLight.png';
import globeDark from '../../assets/images/globeDark.png';
import { useTheme } from '../../context/ThemeContext';
import RotatingTiltedIconWrapper from './RotateAnim';


function ProfileContainer( { ...props}: CircledImageProps ) {
    const { theme } = useTheme();
    
    return (
        <>
        <BubbleHoverCircle 
        $size={props.$bubbleSize}
        $width={props.$bubbleWidth} 
        $height={props.$bubbleHeight}

        $fontSize={props.$fontSize}
        $letteSpacing={props.$letterSpacing}

        $fontSizeHover={props.$fontSizeHover}
        $letteSpacingHover={props.$letterSpacingHover}

        $sizeOuterCircle={props.$sizeOuterCircle}
        $widthOuterCircle={props.$widthOuterCircle}
        $heightOuterCircle={props.$heightOuterCircle}

        $sizeOuterCircleHover={props.$sizeOuterCircleHover}
        $widthOuterCircleHover={props.$widthOuterCircleHover}
        $heightOuterCircleHover={props.$heightOuterCircleHover}
        
        $marginTopAndLeft={props.$marginTopAndLeft}
        $marginTop={props.$marginTop}
        $marginLeft={props.$marginLeft}

        $marginTopAndLeftHover={props.$marginTopAndLeftHover}
        $marginTopHover={props.$marginTopHover}
        $marginLeftHover={props.$marginLeftHover}

        $bubbleTextColor='#ffffff' //Not working but will seek solution
        $displayOnSpan='none'
        $outerBackground={({theme}) =>  theme.containerbg}
        $hoverBackground={({theme}) =>  theme.bubbleHoverClr}
          >
        <CircleBg $circleBgWidth={props.$circleBgWidth} $circleBgHeight={props.$circleBgHeight} $circleBgSize={props.$circleBgSize} $circleBgMargin={props.$circleBgMargin} >
            <Image src={props.$imageUrl} alt={props.$altText || 'Profile'} $imgWidth={props.$imgWidth} $imgHeight={props.$imgHeight} $imgSize={props.$imgSize} $borderRadius='50%'/>
        </CircleBg>
        <div className='outercirle'>
            <RotatingTiltedIconWrapper>
            <img src={  theme === 'dark'? globeLight: globeDark} alt="globe" style={{width: '40px', height: '40px'}}/>
            </RotatingTiltedIconWrapper>
            <span>Nairobi Kenya</span>
        </div>
        </BubbleHoverCircle>
        </>
        
    )
}


function Container({children}: childrenProps) {
    return (
        <>
            <div className="container-fluid" style={{padding: '0 1rem'}}>
                {children}
            </div>
        </>
    )
}

function Row({children}: childrenProps) {
    return (
        <>
            <div className="row">
                {children}
            </div>
        </>
    )
}

const MemoizedProfileContainer = React.memo(ProfileContainer)

export {Container, Row, MemoizedProfileContainer as ProfileContainer};